import React, { Component } from "react";

import { getSalesForPeriodByStation } from "../lib/dataQueries";
import { getStationId } from "../authProvider";

import SalesTodayChart from "../components/salesTodayChart";

class SalesTodayContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  async componentWillMount() {
    const stationId = getStationId();

    if (!stationId) {
      console.warn("Can't find stationid for sales query");
      return;
    }

    // Try twice as websocket can be slow to initialize
    try {
      await this.getData(stationId);
    } catch (e1) {
      try {
        await this.getData(stationId);
      } catch (e) {
        console.error("Error loading charts data");
      }
    }

    this.refresh = setInterval(() => this.getData(stationId), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.refresh);
  }

  getData = async stationId => {
    try {
      const data = await getSalesForPeriodByStation(stationId);
      this.setState({
        data,
      });
    } catch (e) {
      console.error("Error getting stats", e);
    }
  };

  render() {
    const { data } = this.state;

    if (!data || !data.length) return null;

    return <SalesTodayChart data={data} />;
  }
}

export default SalesTodayContainer;



// WEBPACK FOOTER //
// ./src/containers/salesTodayChart.js